import { format } from 'date-fns';
import { IManagementAPISearchRequest } from '../../../types/management-api/policy/search/request';
import { ISearchFilters } from '../../../types/searchFilters';

export const transformSearchQueryParams = (
  params: ISearchFilters
): IManagementAPISearchRequest => {
  return {
    ...(params.policyNumber && {
      policyNumber: params.policyNumber,
    }),
    ...(params.startDate && {
      startDateMin: format(params.startDate, 'yyyy-MM-dd'),
    }),
    ...(params.endDate && {
      startDateMax: format(params.endDate, 'yyyy-MM-dd'),
    }),
    ...(params.firstName && {
      firstName: params.firstName,
    }),
    ...(params.lastName && {
      lastName: params.lastName,
    }),
    ...(params.dateOfBirth && {
      dateOfBirth: format(params.dateOfBirth, 'yyyy-MM-dd'),
    }),
    ...(params.page && {
      page: params.page,
    }),
    ...(params.pageSize && {
      pageSize: params.pageSize,
    }),
    ...(params.isActive && {
      isActive: params.isActive,
    }),
    ...(params.sortByNewestFirst && {
      sortByNewestFirst: params.sortByNewestFirst,
    }),
  };
};
